import React, { useEffect, useState } from 'react';

import { Snackbar, SnackbarContent, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useIsFirstRender } from '@src/shared/hooks/use-is-first-render';

import useOnlineStatus from '@src/shared/hooks/use-online-status';
import useStyles from './styles';
import JetFontIcon,{JET_FONTICON_ALIASES} from '../JetFontIcon';
import useDeviceDetect from '@src/shared/hooks/use-device-detect';
import { useLocation } from 'react-router-dom';

const ConnectionNotifier = () => {
   const [showNotifier, setShowNotifier] = useState(false)
   const { t } = useTranslation()
   const { isBrowserOnline } = useOnlineStatus()
   const { isMobileDevice }= useDeviceDetect()
   const isFirstRender = useIsFirstRender()
   const classes = useStyles();
   const verticalPosition = isMobileDevice ? 'bottom' : 'top'
   const location = useLocation();

   const additionalMargin = !isMobileDevice && location.pathname === '/deliveries'

   useEffect(()=> { 
        if (!isFirstRender) {
            setShowNotifier(true)
        }
   },[isBrowserOnline])


   const handleOnClose = (_event : any ,reason?: string) => {
      if (reason === 'clickaway') { return }
      setShowNotifier(false)
   }

  return <Snackbar open={showNotifier} 
                   anchorOrigin={{ vertical: verticalPosition, horizontal: 'center' }}
                   className={`${classes.snackBarCustomized} ${isBrowserOnline ? 'connected' : 'disconnected'} ${additionalMargin ? 'additionalMargin' : ''}`}
                   autoHideDuration={isBrowserOnline ? 5000 : null}
                   onClose={handleOnClose}
                   >
                    <SnackbarContent 
                    message={<>
                        <Typography variant="body1" className={'body_small_regular '}>
                            <JetFontIcon iconname={isBrowserOnline ? JET_FONTICON_ALIASES.WIFI_SMALL : JET_FONTICON_ALIASES.WIFI_ALERT_SMALL} size={15} /> 
                             {isBrowserOnline ? t('connectionInformation.connected') : t('connectionInformation.disconnected')}
                        </Typography>
                    </>} 
                    action={isBrowserOnline ? <JetFontIcon className={classes.closeButton} size={14} onClick={handleOnClose} iconname={JET_FONTICON_ALIASES.CLOSE} /> : <></>}/>
         </Snackbar>           

}


export default ConnectionNotifier